import React from 'react';
import ShoppingBag32 from '@carbon/icons-react/lib/shopping--bag/32.js';
import DataVis132 from '@carbon/icons-react/lib/data-vis--1/32.js';
import ShareKnowledge32 from '@carbon/icons-react/lib/share-knowledge/32.js';
import StayInside32 from '@carbon/icons-react/lib/stay-inside/32.js';
import Development32 from '@carbon/icons-react/lib/development/32.js';
import CalendarHeatMap32 from '@carbon/icons-react/lib/calendar--heat-map/32.js';
import FingerprintRecognition32 from '@carbon/icons-react/lib/fingerprint-recognition/32.js';
import Forum32 from '@carbon/icons-react/lib/forum/32.js';
import CharacterPatterns32 from '@carbon/icons-react/lib/character-patterns/32.js';
import CloudDataOps32 from '@carbon/icons-react/lib/cloud--data-ops/32.js';
import DataChartLine from '@carbon/icons-react/lib/chart--line--data/32.js';
import TimePlot32 from '@carbon/icons-react/lib/time-plot/32.js';
/* babel-plugin-inline-import '../design/icons/SolarPanel32.svg' */
const SolarPanel32 = "data:image/svg+xml;base64,PCEtLQp0b2RvOiBUaGlzIGlzIGEgZG93bmxvYWRlZCBjYXJib24gaWNvbiBiZWNhdXNlIGl0IGlzIG5vdCB5ZXQgaW4gdGhlIGNhcmJvbiBpY29ucyBwYWNrYWdlLgpTZWUgaHR0cHM6Ly9naXRodWIuY29tL2NhcmJvbi1kZXNpZ24tc3lzdGVtL2NhcmJvbi9pc3N1ZXMvMTAzNzggLgotLT4KPHN2ZwogIGRhdGEtY2FyYm9uLWljb249IlNvbGFyUGFuZWwzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzIgMzIiIGZpbGw9ImN1cnJlbnRDb2xvciIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiAgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQgbWVldCI+CiAgPHBhdGggZD0iTTMwIDI2VjE0SDEzVjI2aDV2MkgydjJIMzBWMjhIMjVWMjZ6bS01LTJWMjFoM3Yzem0tMi0zdjNIMjBWMjF6bS0zLTJWMTZoM3Yzem04IDBIMjVWMTZoM3pNMTggMTZ2M0gxNVYxNnptLTMgOFYyMWgzdjN6bTggNEgyMFYyNmgzek05LjMzMjggMTQuOTgxQTQgNCAwIDExMTYgMTJIMTRhMiAyIDAgMTAtMy4zMzMzIDEuNDkwN3pNMTEgMkgxM1Y2SDExek0yIDExSDZWMTNIMnoiPjwvcGF0aD48cGF0aCBkPSJNNS4zNDMgNC4zNDNINy4zNDNWOC4zNDNINS4zNDN6IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgNi4zNDMgNi4zNDMpIj48L3BhdGg+PHBhdGggZD0iTTE2LjY1NyA0LjM0M0gxOC42NTdWOC4zNDNIMTYuNjU3eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTEzNSAxNy42NTcgNi4zNDMpIj48L3BhdGg+CiAgPHNsb3Q+CiAgICB7I2lmIHRpdGxlfQogICAgICA8dGl0bGU+e3RpdGxlfTwvdGl0bGU+CiAgICB7L2lmfQogIDwvc2xvdD4KPC9zdmc+Cg==";
const apps = {
  'SIA-Shop': {
    icon: /*#__PURE__*/React.createElement(ShoppingBag32, null),
    appName: 'header.app-switcher.shop.name'
  },
  'SIA-Directory': {
    icon: /*#__PURE__*/React.createElement(DataVis132, null),
    appName: 'header.app-switcher.directory.name'
  },
  'SIA-Jobs': {
    icon: /*#__PURE__*/React.createElement(ShareKnowledge32, null),
    appName: 'header.app-switcher.jobs.name'
  },
  'SIA-Wizard': {
    icon: /*#__PURE__*/React.createElement(StayInside32, null),
    appName: 'header.app-switcher.wizard.name'
  },
  'SIA-Reference-gallery': {
    icon: /*#__PURE__*/React.createElement(Development32, null),
    appName: 'header.app-switcher.reference-gallery.name'
  },
  'SIA-Cloud': {
    icon: /*#__PURE__*/React.createElement(CloudDataOps32, null),
    appName: 'header.app-switcher.cloud.name'
  },
  'SIA-Agenda': {
    icon: /*#__PURE__*/React.createElement(CalendarHeatMap32, null),
    appName: 'header.app-switcher.agenda.name'
  },
  'Value-App': {
    icon: /*#__PURE__*/React.createElement(TimePlot32, null),
    appName: 'header.app-switcher.value-app.name'
  },
  'SIA-Account': {
    icon: /*#__PURE__*/React.createElement(FingerprintRecognition32, null),
    appName: 'header.app-switcher.account.name'
  },
  'SIA-Ecom': {
    icon: /*#__PURE__*/React.createElement(Forum32, null),
    appName: 'header.app-switcher.ecom.name'
  },
  'SIA-Term': {
    icon: /*#__PURE__*/React.createElement(CharacterPatterns32, null),
    appName: 'header.app-switcher.term.name'
  },
  'SIA-Energy-tools': {
    icon: /*#__PURE__*/React.createElement("img", {
      src: SolarPanel32,
      alt: ''
    }),
    appName: 'header.app-switcher.energy-tools.name'
  },
  'SIA-Benchmarking': {
    icon: /*#__PURE__*/React.createElement(DataChartLine, null),
    appName: 'header.app-switcher.benchmarking.name'
  }
};
export default apps;